"use client";

import React, { useState } from "react";

import { Button } from "./ui/button";
import { Check, Copy, ArrowRight } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/images/logo.svg";
import qrIcon from "../assets/images/80eight/88.svg";
import { useToast } from "../hooks/use-toast";

export default function Receive() {
  const [copied, setCopied] = useState(false);
  const { userProfile } = useAuth();
  const { toast } = useToast();
  const payId = userProfile?.payID;

  // Generate payment URL for QR code
  const paymentUrl = payId
    ? `${window.location.origin}/trading/digitalWallet?payId=${payId}&tab=pay`
    : "";

  const handleCopy = () => {
    navigator.clipboard.writeText(payId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast({
      description: "PayID Copied Successfully",
      variant: "eighty",
    });
  };

  return (
    <div className="flex gap-4 w-full">
      {/* Left: Info Card - Hidden on mobile */}
      <div className="hidden lg:flex flex-1 border border-[#EBE9EF] rounded-2xl p-6 bg-white items-center justify-between min-h-[350px]">
        <div className="flex flex-col gap-4">
          <h3 className="text-[16px] font-semibold text-[#423E51] leading-[24px]">
            Receive payments with no hasle
          </h3>
          <p className="text-[14px] font-normal text-[#6D6584] leading-[20px]">
            Simply scan the QR code to receive a payment into your wallet
          </p>
          <Button
            variant="link"
            className="text-[#EB3366] text-[14px] font-semibold p-0 h-auto justify-start gap-2"
          >
            Learn more
            <ArrowRight size={16} />
          </Button>
        </div>
        {/* Decorative QR Icon */}
        <img src={qrIcon} alt="" className="w-[99px] h-[80px]" />
      </div>

      {/* Right: QR Code Card - Full width on mobile */}
      <div className="w-full lg:w-[294px] border border-[#EBE9EF] rounded-2xl p-4 bg-white flex flex-col items-center gap-4">
        {/* QR Code - Order changed for mobile (QR first) */}
        <div className="relative order-1 lg:order-2">
          <QRCodeSVG
            value={paymentUrl || "88PAY"}
            size={220}
            level="M"
            imageSettings={{
              src: logo,
              x: undefined,
              y: undefined,
              height: 60,
              width: 60,
              excavate: true,
            }}
          />
        </div>

        {/* PayID + Copy Button */}
        <div className="flex items-center justify-center gap-2 lg:gap-4 w-full order-2 lg:order-1">
          <span className="text-[14px] text-[#6D6584]">
            PayID: <span className="text-[#423E51]">{payId}</span>
          </span>
          <Button
            variant="outline"
            className="rounded-lg lg:rounded-full w-[32px] h-[32px] lg:w-[48px] lg:h-[48px] p-0 border-[#EBE9EF]"
            onClick={handleCopy}
          >
            {copied ? (
              <Check className="h-4 w-4 text-green-500" />
            ) : (
              <Copy className="h-4 w-4 text-[#6D6584]" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
